/** @jsxRuntime classic */
/** @jsx jsx */
import { jsx } from '@emotion/react';
import ouiStyle from '@goldwasserexchange/oui-style';

const style: ouiStyle.InStyle = {
  widthLines: 'full',
  lines: 0.1,
  backgroundColor: ouiStyle.Constants.Colors.fade,
  marginTop: 'double',
};

const css = ouiStyle.makeCss(style);

export const ArticleLine = () => (
  <hr
    css={css}
  />
);
